import {Component, OnInit} from '@angular/core';
import { GlobalMessageComponent, IconComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-global-message',
    templateUrl: './efa-global-message.component.html',
    styleUrls: ['./efa-global-message.component.scss'],
    imports: [IconComponent, AsyncPipe, TranslatePipe]
})
export class EfaGlobalMessageComponent extends GlobalMessageComponent implements OnInit {

  ngOnInit(): void {
    super.ngOnInit();
  }

}
